import { Observable, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import { GoogleMap } from '@angular/google-maps';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';

import { moveItemInArray, CdkDragDrop } from "@angular/cdk/drag-drop";

import { SpinnerService } from '../../services/spinner.service';
import { ApiReservationFacility, ApiSetReservationFacilitiesRequest, ApiFile, SettingFile } from '../../api-client-module';
import { ReservationFacilityAttribute } from '../../firestore-models/reservation-facility-attribute';
import { UploadedFile } from '../../firestore-models/uploaded-file';
import { ProjectLanguage } from '../../firestore-models/project-language';
import { Facility } from '../../firestore-models/facility';
import { ReservationFacility } from '../../firestore-models/reservation-facility';
import { SplatsKeyDevice } from '../../firestore-models/splats-key-device';

import { ConfigurationService } from '../../configuration.service';
import { ApiClientService } from '../../api-client.service';
import { AppConst } from '../../app-const';
import { ApiReservationQuestion } from '../../api-client-module';
import { MultiNameDialogComponent } from '../../common/multi-name-dialog/multi-name-dialog.component';
import { MultiDescDialogComponent } from '../../common/multi-desc-dialog/multi-desc-dialog.component';
import { MultiUserInputTitleDialogComponent } from '../../common/multi-user-input-title-dialog/multi-user-input-title-dialog.component';
import { MultiSendMailTitleDialogComponent } from '../../common/multi-send-mail-title-dialog/multi-send-mail-title-dialog.component';
import { MultiSendMailMessageDialogComponent } from '../../common/multi-send-mail-message-dialog/multi-send-mail-message-dialog.component';
import { MultiMailTitleDialogComponent } from '../../common/multi-mail-title-dialog/multi-mail-title-dialog.component';
import { MultiMailMessageDialogComponent } from '../../common/multi-mail-message-dialog/multi-mail-message-dialog.component';
import { SelectUploadedFileDialogComponent } from '../../select-uploaded-file-dialog/select-uploaded-file-dialog.component';
import { MultiRitemDialogComponent } from '../../common/multi-ritem-dialog/multi-ritem-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';

import { SelectReservationQuestionsDialogComponent } from '../select-reservation-questions-dialog/select-reservation-questions-dialog.component';

export interface ReservationFacilityDialogData {
  change_type: number;
  reservationFacility?: ApiReservationFacility;
}

export interface marker {
  lat: number;
  lng: number;
  draggable: boolean;
}

@Component({
  selector: 'app-reservation-facility-dialog',
  templateUrl: './reservation-facility-dialog.component.html',
  styleUrls: ['./reservation-facility-dialog.component.css'],
  standalone: false,
  providers: [
    // このコンポーネントとその子要素専用のDateAdapterインスタンスを作成 //(0703)
    { provide: DateAdapter, useClass: NativeDateAdapter },
  ]
})
export class ReservationFacilityDialogComponent implements OnInit {

  //予約設備情報
  reservationFacility?: ApiReservationFacility;
  //各予約設備情報に紐付くプロジェクトID
  projectId: string;
  questionIDs: string[] = [];

  display: string = 'basic';
  isAdded: boolean = false;
  isInit: boolean = true;
  projectLanguages!: Array<ProjectLanguage>;

  //予約設備情報フォーム
  reservationFacilityFormGroup!: FormGroup;
  reservationFacilityIdControl!: FormControl;
  reservationFacilityAttributeIdControl!: FormControl;
  autoTransContral!: FormControl;
  reservationFacilityNamesControl!: FormControl;
  reservationFacilityDescsControl!: FormControl;
  reservationFacilityLatControl!: FormControl;
  reservationFacilityLngControl!: FormControl;
  showMarkerControl!: FormControl;
  reservationUserInputTitlesControl!: FormControl;
  reservationSendMailTitlesControl!: FormControl;
  reservationSendMailMessages1Control!: FormControl;
  reservationSendMailMessages2Control!: FormControl;
  reservationSendMailMessages3Control!: FormControl;
  isExhibitInfoMessageControl!: FormControl;
  isHideReservationCancelDateMessageControl!: FormControl;
  isHideReservationSendMailCancelMessageControl!: FormControl;
  onedayControl!: FormControl;
  twodayControl!: FormControl;
  threedayControl!: FormControl;
  fourdayControl!: FormControl;
  fivedayControl!: FormControl;
  sixdayControl!: FormControl;
  sevendayControl!: FormControl;
  secretariatMailAddressesControl!: FormControl;
  reservationSecretariatMailMessages1Control!: FormControl;
  reservationRemindMailTitlesControl!: FormControl;
  reservationRemindMailMessages1Control!: FormControl;
  reservationRemindMailMessages2Control!: FormControl;
  reservationRemindMailMessages3Control!: FormControl;
  reservationCancelMailTitlesControl!: FormControl;
  reservationCancelMailMessages1Control!: FormControl;
  reservationCancelMailMessages2Control!: FormControl;
  reservationCancelMailMessages3Control!: FormControl;
  reservationSecretariatCancelMailMessages1Control!: FormControl;
  reservationMethodControl!: FormControl;
  lotteryMethodControl!: FormControl;
  reservationCancelControl!: FormControl;
  reservationUnitControl!: FormControl;
  reservationCountControl!: FormControl;
  dispStartDateControl!: FormControl;
  dispEndDateControl!: FormControl;
  reservationStartDateControl!: FormControl;
  reservationEndDateControl!: FormControl;
  reservationOpenStartDateControl!: FormControl;
  reservationOpenEndDateControl!: FormControl;
  isHideReservationEndDateControl!: FormControl;
  isMultiSelectControl!: FormControl;
  sundayControl!: FormControl;
  mondayControl!: FormControl;
  tuesdayControl!: FormControl;
  wednesdayControl!: FormControl;
  thursdayControl!: FormControl;
  fridayControl!: FormControl;
  saturdayControl!: FormControl;
  isVisibledCompanyNameControl!: FormControl;
  isVisibledDepartmentControl!: FormControl;
  isVisibledJobTitleControl!: FormControl;
  isVisibledSurnameChineseControl!: FormControl;
  isVisibledNameChineseControl!: FormControl;
  isVisibledFamilyNameControl!: FormControl;
  isVisibledFirstNameControl!: FormControl;
  isVisibledGenderControl!: FormControl;
  isVisibledBirthdayControl!: FormControl;
  isVisibledAddressControl!: FormControl;
  isVisibledMobilePhoneNumberControl!: FormControl;
  isVisibledUserRequestControl!: FormControl;
  isHideReservationConditionControl!: FormControl;
  reservationOnHoldMailTitlesControl!: FormControl;
  reservationOnHoldMailMessages1Control!: FormControl;
  reservationOnHoldMailMessages2Control!: FormControl;
  reservationOnHoldMailMessages3Control!: FormControl;
  reservationLostMailTitlesControl!: FormControl;
  reservationLostMailMessages1Control!: FormControl;
  reservationLostMailMessages2Control!: FormControl;
  reservationLostMailMessages3Control!: FormControl;
  reservationLotteryDateControl!: FormControl;
  splatsApiTypeControl!: FormControl;
  splatsKeyDeviceIdControl!: FormControl;
  splatsUnitNoControl!: FormControl;
  splatsBorrowGraceMinutesControl!: FormControl;
  splatsReturnGraceMinutesControl!: FormControl;
  isVisibledSplatsQrCompanyNameControl!: FormControl;
  isVisibledSplatsQrDepartmentControl!: FormControl;
  isVisibledSplatsQrJobTitleControl!: FormControl;
  isVisibledSplatsQrSurnameNameChineseControl!: FormControl;
  isVisibledSplatsQrFamilyFirstNameControl!: FormControl;
  isVisibledSplatsQrGenderControl!: FormControl;
  isVisibledSplatsQrBirthdayControl!: FormControl;
  isVisibledSplatsQrAddressControl!: FormControl;
  isVisibledSplatsQrMobilePhoneNumberControl!: FormControl;
  isVisibledSplatsQrUserRequestControl!: FormControl;


  inReservationFacilityId = '';

  remindCount: number = 0;

  reservationMethods = AppConst.RESERVATION_METHODS;
  lotteryMethods = AppConst.LOTTERY_METHODS;
  reservationUnits = AppConst.RESERVATION_UNITS;
  reservationNumberDays = AppConst.RESERVATION_NUMBER_DAYS;
  reservationPastNumberDays = AppConst.RESERVATION_PAST_NUMBER_DAYS;
  hours = AppConst.HOURS;
  minutes = AppConst.MINUTES;

  private reservationFacilityAttributesCollection!: AngularFirestoreCollection<ReservationFacilityAttribute>;
  reservationFacilityAttributes!: Observable<ReservationFacilityAttribute[]>;

  private facilitiesCollection!: AngularFirestoreCollection<Facility>;
  facilitiesObservable!: Observable<Facility[]>;
  facilitiesSubscribe!: Subscription;
  private reservationFacilitiesCollection!: AngularFirestoreCollection<ReservationFacility>;
  reservationFacilitiesObservable!: Observable<ReservationFacility[]>;
  reservationFacilitiesSubscribe!: Subscription;
  reservationFacilities: ReservationFacility[] = [];
  keyDevices: SplatsKeyDevice[] = [];
  units: any[] = [];
  splatsApiTypes = [
    {key: 0, value: ''},
    {key: AppConst.SPLATS_API_TYPE_SHARE, value: '共用環境'},
    {key: AppConst.SPLATS_API_TYPE_PRODUCTION, value: '本番環境'},
  ];
  splatsGraceMinutes: { key: number; value: string }[] = [];

  reservationFacilityFiles: SettingFile[] = [];

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';
  private langChangeSub!: Subscription; // TranslateServiceの購読を管理
  
  //GoogleMap表示
  zoom = AppConst.ZOOM_INITIAL_VALUE;
  center!: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    disableDefaultUI: true
  };
  currentPosition!: google.maps.LatLngLiteral
  currentPositionMarkerOption: google.maps.MarkerOptions = {
    draggable: true
  };

  private map!: GoogleMap;
  // @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  @ViewChild(GoogleMap, { static: false }) set contentMap(contentMap: GoogleMap) {
    if (contentMap) {
      this.map = contentMap;
    }
  }
  private searchField!: ElementRef;
  // @ViewChild("mapSearchField") searchField!: ElementRef;
  @ViewChild("mapSearchField", { static: false }) set contentSearchField(contentSearchField: ElementRef) {
    if (contentSearchField) {
      this.searchField = contentSearchField;
    }
  }
  private searchFieldExecute!: ElementRef;
  // @ViewChild("mapSearchFieldExecute") searchFieldExecute!: ElementRef;
  @ViewChild("mapSearchFieldExecute", { static: false }) set contentMapSearchFieldExecute(contentMapSearchFieldExecute: ElementRef) {
    if (contentMapSearchFieldExecute) {
      this.searchFieldExecute = contentMapSearchFieldExecute;
    }
  }
  private searchFieldClear!: ElementRef;
  // @ViewChild("mapSearchFieldClear") searchFieldClear!: ElementRef;
  @ViewChild("mapSearchFieldClear", { static: false }) set contentMapSearchFieldClear(contentMapSearchFieldClear: ElementRef) {
    if (contentMapSearchFieldClear) {
      this.searchFieldClear = contentMapSearchFieldClear;
      if (!this.isInit) {
        this.searchBox = new google.maps.places.SearchBox(
          this.searchField.nativeElement
        );
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
          this.searchField.nativeElement
        );
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
          this.searchFieldExecute.nativeElement
        );
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
          this.searchFieldClear.nativeElement
        );
      }
    }
  }
  searchBox!: google.maps.places.SearchBox;

  readonly RESERVATION_METHOD_FIRST: number = AppConst.RESERVATION_METHOD_FIRST;
  readonly RESERVATION_METHOD_ON_HOLD: number = AppConst.RESERVATION_METHOD_ON_HOLD;
  readonly RESERVATION_METHOD_LOTTERY: number = AppConst.RESERVATION_METHOD_LOTTERY;
  readonly RESERVATION_UNIT_TIME: number = AppConst.RESERVATION_UNIT_TIME;

  constructor(
    public dialogRef: MatDialogRef<ReservationFacilityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReservationFacilityDialogData,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
    private dateAdapter: DateAdapter<any>
  ) {
    this.projectId = this.configurationService.getProjectId();
    for (let i = 0; i <= 60; i++) {
      this.splatsGraceMinutes.push({key: i, value: `${i}${this.translate.instant('分')}`});
    }
   }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.reservationFacilityAttributesCollection = this.angularFirestore.collection<ReservationFacilityAttribute>(
      AppConst.FIRESTORE_RESERVATION_FACILITY_ATTR, ref => ref.where('project_id', '==', this.projectId).orderBy('attribute_id', 'asc'));
    this.reservationFacilityAttributes = this.reservationFacilityAttributesCollection.valueChanges({ idField: 'id' });

    this.reservationFacility = this.data.reservationFacility;
    this.currentLang = this.translate.currentLang;
    // 1. コンポーネント初期化時に現在の言語でカレンダーを設定
    this.setCalendarLocale(this.currentLang);

    // 2. アプリケーションの言語が変更されたら、カレンダーの言語も動的に追従させる
    this.langChangeSub = this.translate.onLangChange.subscribe(event => {
      this.setCalendarLocale(event.lang);
    });

    this.projectBaseLang = this.configurationService.getProject().project_base_lang;
    if (!this.reservationFacility) {
      this.reservationFacility = {
        reservation_facility_id: '',
        reservation_facility_attribute_id: '',
        reservation_facility_names: [],
        reservation_facility_descs: null as any,
        reservation_user_input_titles: [],
        reservation_send_mail_titles: [],
        reservation_send_mail_messages1: null as any,
        reservation_send_mail_messages2: null as any,
        reservation_send_mail_messages3: null as any,
        secretariat_mail_addresses: [],
        reservation_secretariat_mail_messages1: null as any,
        is_exhibit_info_message: false,
        is_hide_reservation_cancel_date_message: false,
        is_hide_reservation_send_mail_cancel_message: false,
        reservation_cancel_mail_titles: [],
        reservation_cancel_mail_messages1: null as any,
        reservation_cancel_mail_messages2: null as any,
        reservation_cancel_mail_messages3: null as any,
        reservation_secretariat_cancel_mail_messages1: null as any,
        remind_days: [false, false, false, false, false, false, false],
        reservation_remind_mail_titles: [],
        reservation_remind_mail_messages1: null as any,
        reservation_remind_mail_messages2: null as any,
        reservation_remind_mail_messages3: null as any,
        reservation_facility_files: [],
        reservation_select_times: [],
        latitude: this.configurationService.getProject().project_geopoint && this.configurationService.getProject().project_geopoint.latitude ? this.configurationService.getProject().project_geopoint.latitude : AppConst.LATITUDE_INITIAL_VALUE,
        longitude: this.configurationService.getProject().project_geopoint && this.configurationService.getProject().project_geopoint.longitude ? this.configurationService.getProject().project_geopoint.longitude : AppConst.LONGITUDE_INITIAL_VALUE,
        show_marker: false,
        project_id: this.projectId,
        reservation_method: AppConst.RESERVATION_METHOD_FIRST,
        lottery_method: AppConst.LOTTERY_METHOD_AUTO,
        reservation_cancel: AppConst.RESERVATION_NUMBER_DAY_00,
        reservation_unit: AppConst.RESERVATION_UNIT_PERIOD,
        reservation_count: null as any,
        disp_start_date: null as any,
        disp_end_date: null as any,
        reservation_start_date: AppConst.RESERVATION_NUMBER_DAY_01,
        reservation_end_date: AppConst.RESERVATION_NUMBER_DAY_00,
        reservation_open_start_date: null as any,
        reservation_open_end_date: null as any,
        is_hide_reservation_end_date: false,
        holidays: [false, false, false, false, false, false, false],
        enabled: true,
        is_visibled_company_name: true,
        is_visibled_department: true,
        is_visibled_job_title: true,
        is_visibled_surname_chinese: true,
        is_visibled_name_chinese: true,
        is_visibled_family_name: true,
        is_visibled_first_name: true,
        is_visibled_birthday: true,
        is_visibled_gender: true,
        is_visibled_address: true,
        is_visibled_mobile_phone_number: true,
        is_visibled_user_request: true,
        is_hide_reservation_condition: false,
        questions: [],
        is_multi_select: false,
        reservation_on_hold_mail_titles: [],
        reservation_on_hold_mail_messages1: null as any,
        reservation_on_hold_mail_messages2: null as any,
        reservation_on_hold_mail_messages3: null as any,
        reservation_lost_mail_titles: [],
        reservation_lost_mail_messages1: null as any,
        reservation_lost_mail_messages2: null as any,
        reservation_lost_mail_messages3: null as any,
        reservation_lottery_date: AppConst.RESERVATION_NUMBER_DAY_01,
        splats_api_type: 0,
        splats_key_device_id: '',
        splats_unit_no: '',
        splats_borrow_grace_minutes: 0,
        splats_return_grace_minutes: 0,
        is_visibled_splats_qr_company_name: false,
        is_visibled_splats_qr_department: false,
        is_visibled_splats_qr_job_title: false,
        is_visibled_splats_qr_surname_name_chinese: false,
        is_visibled_splats_qr_family_first_name: false,
        is_visibled_splats_qr_gender: false,
        is_visibled_splats_qr_birthday: false,
        is_visibled_splats_qr_address: false,
        is_visibled_splats_qr_mobile_phone_number: false,
        is_visibled_splats_qr_user_request: false,
      };
      this.isAdded = true;
    } else {
      this.inReservationFacilityId = this.reservationFacility.reservation_facility_id;
    }

    // 施設取得
    this.facilitiesCollection = this.angularFirestore.collection<Facility>(
      AppConst.FIRESTORE_FACILITIES, ref => ref.where('project_id', '==', this.projectId));
    this.facilitiesObservable = this.facilitiesCollection.valueChanges({ idField: 'id' });
    this.facilitiesSubscribe = this.facilitiesObservable.subscribe(facilities => {
      let keyDevices: SplatsKeyDevice[] = [];
      for (const facility of facilities) {
        if (!!facility.splats_key_devices) {
          for (const keyDevice of facility.splats_key_devices) {
            if (!keyDevices.find(item => item.id === keyDevice.id)) {
              keyDevices.push(keyDevice);
            }
          }
        }
      }
      keyDevices = keyDevices.sort((a, b) => {
        return (a.id < b.id ? -1 : 1);
      });
      this.keyDevices = keyDevices;

      if (!!this.reservationFacilitiesSubscribe) {
        this.reservationFacilitiesSubscribe.unsubscribe();
      }
      // 予約施設取得
      this.reservationFacilitiesCollection = this.angularFirestore.collection<ReservationFacility>(
        AppConst.FIRESTORE_RESERVATION_FACILITIES, ref => ref.where('project_id', '==', this.projectId));
      this.reservationFacilitiesObservable = this.reservationFacilitiesCollection.valueChanges({ idField: 'id' });
      this.reservationFacilitiesSubscribe = this.reservationFacilitiesObservable.subscribe(reservationFacilities => {
        this.reservationFacilities = reservationFacilities;
        this.createUnitNo(!!this.splatsKeyDeviceIdControl ? this.splatsKeyDeviceIdControl.value: this.reservationFacility!.splats_key_device_id);
      });
    });

    this.currentPosition = {
      lat: this.reservationFacility.latitude!,
      lng: this.reservationFacility.longitude!
    }
    this.center = this.currentPosition;

    if (this.reservationFacility.remind_days) {
      this.remindCount = this.reservationFacility.remind_days.filter(item => item == true).length;
    }
    this.getQuestionIDs();
    this.createForm();
    this.reservationFacilityIdControl = this.reservationFacilityFormGroup.get('reservationFacilityId') as FormControl;
    this.reservationFacilityAttributeIdControl = this.reservationFacilityFormGroup.get('reservationFacilityAttributeId') as FormControl;
    this.reservationFacilityNamesControl = this.reservationFacilityFormGroup.get('reservationFacilityNames') as FormControl;
    this.reservationFacilityDescsControl = this.reservationFacilityFormGroup.get('reservationFacilityDescs') as FormControl;
    this.reservationFacilityLatControl = this.reservationFacilityFormGroup.get('reservationFacilityLat') as FormControl;
    this.reservationFacilityLngControl = this.reservationFacilityFormGroup.get('reservationFacilityLng') as FormControl;
    this.reservationUserInputTitlesControl = this.reservationFacilityFormGroup.get('reservationUserInputTitles') as FormControl;
    this.reservationSendMailTitlesControl = this.reservationFacilityFormGroup.get('reservationSendMailTitles') as FormControl;
    this.reservationSendMailMessages1Control = this.reservationFacilityFormGroup.get('reservationSendMailMessages1') as FormControl;
    this.reservationSendMailMessages2Control = this.reservationFacilityFormGroup.get('reservationSendMailMessages2') as FormControl;
    this.reservationSendMailMessages3Control = this.reservationFacilityFormGroup.get('reservationSendMailMessages3') as FormControl;
    this.secretariatMailAddressesControl = this.reservationFacilityFormGroup.get('secretariatMailAddresses') as FormControl;
    this.reservationSecretariatMailMessages1Control = this.reservationFacilityFormGroup.get('reservationSecretariatMailMessages1') as FormControl;
    this.isExhibitInfoMessageControl = this.reservationFacilityFormGroup.get('isExhibitInfoMessage') as FormControl;
    this.isHideReservationCancelDateMessageControl = this.reservationFacilityFormGroup.get('isHideReservationCancelDateMessage') as FormControl;
    this.isHideReservationSendMailCancelMessageControl = this.reservationFacilityFormGroup.get('isHideReservationSendMailCancelMessage') as FormControl;
    this.reservationCancelMailTitlesControl = this.reservationFacilityFormGroup.get('reservationCancelMailTitles') as FormControl;
    this.reservationCancelMailMessages1Control = this.reservationFacilityFormGroup.get('reservationCancelMailMessages1') as FormControl;
    this.reservationCancelMailMessages2Control = this.reservationFacilityFormGroup.get('reservationCancelMailMessages2') as FormControl;
    this.reservationCancelMailMessages3Control = this.reservationFacilityFormGroup.get('reservationCancelMailMessages3') as FormControl;
    this.reservationSecretariatCancelMailMessages1Control = this.reservationFacilityFormGroup.get('reservationSecretariatCancelMailMessages1') as FormControl;
    this.onedayControl = this.reservationFacilityFormGroup.get('oneday') as FormControl;
    this.twodayControl = this.reservationFacilityFormGroup.get('twoday') as FormControl;
    this.threedayControl = this.reservationFacilityFormGroup.get('threeday') as FormControl;
    this.fourdayControl = this.reservationFacilityFormGroup.get('fourday') as FormControl;
    this.fivedayControl = this.reservationFacilityFormGroup.get('fiveday') as FormControl;
    this.sixdayControl = this.reservationFacilityFormGroup.get('sixday') as FormControl;
    this.sevendayControl = this.reservationFacilityFormGroup.get('sevenday') as FormControl;
    this.reservationRemindMailTitlesControl = this.reservationFacilityFormGroup.get('reservationRemindMailTitles') as FormControl;
    this.reservationRemindMailMessages1Control = this.reservationFacilityFormGroup.get('reservationRemindMailMessages1') as FormControl;
    this.reservationRemindMailMessages2Control = this.reservationFacilityFormGroup.get('reservationRemindMailMessages2') as FormControl;
    this.reservationRemindMailMessages3Control = this.reservationFacilityFormGroup.get('reservationRemindMailMessages3') as FormControl;
    this.showMarkerControl = this.reservationFacilityFormGroup.get('showMarker') as FormControl;
    this.reservationMethodControl = this.reservationFacilityFormGroup.get('reservationMethod') as FormControl;
    this.lotteryMethodControl = this.reservationFacilityFormGroup.get('lotteryMethod') as FormControl;
    this.reservationCancelControl = this.reservationFacilityFormGroup.get('reservationCancel') as FormControl;
    this.reservationUnitControl = this.reservationFacilityFormGroup.get('reservationUnit') as FormControl;
    this.reservationCountControl = this.reservationFacilityFormGroup.get('reservationCount') as FormControl;
    this.dispStartDateControl = this.reservationFacilityFormGroup.get('dispStartDate') as FormControl;
    this.dispEndDateControl = this.reservationFacilityFormGroup.get('dispEndDate') as FormControl;
    this.reservationStartDateControl = this.reservationFacilityFormGroup.get('reservationStartDate') as FormControl;
    this.reservationEndDateControl = this.reservationFacilityFormGroup.get('reservationEndDate') as FormControl;
    this.reservationOpenStartDateControl = this.reservationFacilityFormGroup.get('reservationOpenStartDate') as FormControl;
    this.reservationOpenEndDateControl = this.reservationFacilityFormGroup.get('reservationOpenEndDate') as FormControl;
    this.isHideReservationEndDateControl = this.reservationFacilityFormGroup.get('isHideReservationEndDate') as FormControl;
    this.sundayControl = this.reservationFacilityFormGroup.get('sunday') as FormControl;
    this.mondayControl = this.reservationFacilityFormGroup.get('monday') as FormControl;
    this.tuesdayControl = this.reservationFacilityFormGroup.get('tuesday') as FormControl;
    this.wednesdayControl = this.reservationFacilityFormGroup.get('wednesday') as FormControl;
    this.thursdayControl = this.reservationFacilityFormGroup.get('thursday') as FormControl;
    this.fridayControl = this.reservationFacilityFormGroup.get('friday') as FormControl;
    this.saturdayControl = this.reservationFacilityFormGroup.get('saturday') as FormControl;
    this.isVisibledCompanyNameControl = this.reservationFacilityFormGroup.get('isVisibledCompanyName') as FormControl;
    this.isVisibledDepartmentControl = this.reservationFacilityFormGroup.get('isVisibledDepartment') as FormControl;
    this.isVisibledJobTitleControl = this.reservationFacilityFormGroup.get('isVisibledJobTitle') as FormControl;
    this.isVisibledSurnameChineseControl = this.reservationFacilityFormGroup.get('isVisibledSurnameChinese') as FormControl;
    this.isVisibledNameChineseControl = this.reservationFacilityFormGroup.get('isVisibledNameChinese') as FormControl;
    this.isVisibledFamilyNameControl = this.reservationFacilityFormGroup.get('isVisibledFamilyName') as FormControl;
    this.isVisibledFirstNameControl = this.reservationFacilityFormGroup.get('isVisibledFirstName') as FormControl;
    this.isVisibledGenderControl = this.reservationFacilityFormGroup.get('isVisibledGender') as FormControl;
    this.isVisibledBirthdayControl = this.reservationFacilityFormGroup.get('isVisibledBirthday') as FormControl;
    this.isVisibledAddressControl = this.reservationFacilityFormGroup.get('isVisibledAddress') as FormControl;
    this.isVisibledMobilePhoneNumberControl = this.reservationFacilityFormGroup.get('isVisibledMobilePhoneNumber') as FormControl;
    this.isVisibledUserRequestControl = this.reservationFacilityFormGroup.get('isVisibledUserRequest') as FormControl;
    this.isHideReservationConditionControl = this.reservationFacilityFormGroup.get('isHideReservationCondition') as FormControl;
    this.isMultiSelectControl = this.reservationFacilityFormGroup.get('isMultiSelect') as FormControl;
    this.reservationOnHoldMailTitlesControl = this.reservationFacilityFormGroup.get('reservationOnHoldMailTitles') as FormControl;
    this.reservationOnHoldMailMessages1Control = this.reservationFacilityFormGroup.get('reservationOnHoldMailMessages1') as FormControl;
    this.reservationOnHoldMailMessages2Control = this.reservationFacilityFormGroup.get('reservationOnHoldMailMessages2') as FormControl;
    this.reservationOnHoldMailMessages3Control = this.reservationFacilityFormGroup.get('reservationOnHoldMailMessages3') as FormControl;
    this.reservationLostMailTitlesControl = this.reservationFacilityFormGroup.get('reservationLostMailTitles') as FormControl;
    this.reservationLostMailMessages1Control = this.reservationFacilityFormGroup.get('reservationLostMailMessages1') as FormControl;
    this.reservationLostMailMessages2Control = this.reservationFacilityFormGroup.get('reservationLostMailMessages2') as FormControl;
    this.reservationLostMailMessages3Control = this.reservationFacilityFormGroup.get('reservationLostMailMessages3') as FormControl;
    this.reservationLotteryDateControl = this.reservationFacilityFormGroup.get('reservationLotteryDate') as FormControl;
    this.splatsApiTypeControl = this.reservationFacilityFormGroup.get('splatsApiType') as FormControl;
    this.splatsKeyDeviceIdControl = this.reservationFacilityFormGroup.get('splatsKeyDeviceId') as FormControl;
    this.splatsUnitNoControl = this.reservationFacilityFormGroup.get('splatsUnitNo') as FormControl;
    this.splatsBorrowGraceMinutesControl = this.reservationFacilityFormGroup.get('splatsBorrowGraceMinutes') as FormControl;
    this.splatsReturnGraceMinutesControl = this.reservationFacilityFormGroup.get('splatsReturnGraceMinutes') as FormControl;
    this.isVisibledSplatsQrCompanyNameControl = this.reservationFacilityFormGroup.get('isVisibledSplatsQrCompanyName') as FormControl;
    this.isVisibledSplatsQrDepartmentControl = this.reservationFacilityFormGroup.get('isVisibledSplatsQrDepartment') as FormControl;
    this.isVisibledSplatsQrJobTitleControl = this.reservationFacilityFormGroup.get('isVisibledSplatsQrJobTitle') as FormControl;
    this.isVisibledSplatsQrSurnameNameChineseControl = this.reservationFacilityFormGroup.get('isVisibledSplatsQrSurnameNameChinese') as FormControl;
    this.isVisibledSplatsQrFamilyFirstNameControl = this.reservationFacilityFormGroup.get('isVisibledSplatsQrFamilyFirstName') as FormControl;
    this.isVisibledSplatsQrGenderControl = this.reservationFacilityFormGroup.get('isVisibledSplatsQrGender') as FormControl;
    this.isVisibledSplatsQrBirthdayControl = this.reservationFacilityFormGroup.get('isVisibledSplatsQrBirthday') as FormControl;
    this.isVisibledSplatsQrAddressControl = this.reservationFacilityFormGroup.get('isVisibledSplatsQrAddress') as FormControl;
    this.isVisibledSplatsQrMobilePhoneNumberControl = this.reservationFacilityFormGroup.get('isVisibledSplatsQrMobilePhoneNumber') as FormControl;
    this.isVisibledSplatsQrUserRequestControl = this.reservationFacilityFormGroup.get('isVisibledSplatsQrUserRequest') as FormControl;

    this.getFiles();
  }

  ngAfterViewInit(): void {
    // 住所検索用
    this.searchBox = new google.maps.places.SearchBox(
      this.searchField.nativeElement
    );
    this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
      this.searchField.nativeElement
    );
    this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
      this.searchFieldExecute.nativeElement
    );
    this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
      this.searchFieldClear.nativeElement
    );
  }

  ngOnDestroy(): void {
    this.facilitiesSubscribe.unsubscribe();
    this.reservationFacilitiesSubscribe.unsubscribe();
  }

  /** //(0703)
  * Datepickerのロケールを設定するプライベートメソッド
  * @param lang 設定したい言語コード (例: 'en', 'ja')
  */
  private setCalendarLocale(lang: string): void {
    // 言語に応じたロケールを設定
    const locale = lang === 'en' ? 'en-US' : 'ja-JP';
    this.dateAdapter.setLocale(locale);
  }

  // 表示切り替え
  onDisplay(display: string) {
    this.display = display;
    // google map(ViewChild)に関して、初回ダイアログ起動時はngAfterViewInit()を通過することで設定できるが、
    // タブ切り替え操作によるページ切り替え(*ngIf処理)でhtmlの要素が消去されるとViewChildも消去される。
    // タブ切り替え操作による遷移ではngAfterViewInit()が実行されないため、ViewChild生成のタイミングで設定する。
    this.isInit = false;
  }

  // GoogleMap上のピンとフォームの値を一致させる
  onMerkerDragEnd(event: any) {
    this.reservationFacilityLatControl.setValue(this.round(event.latLng!.lat(), 8));
    this.reservationFacilityLngControl.setValue(this.round(event.latLng!.lng(), 8));
  }

  // ピンの位置
  private round(value: number, digits: number): number {
    let pow: number = 1;
    if (digits > 0) {
      pow = Math.pow(10, digits);
    }
    return Math.round(value * pow) / pow;
  }

  // Googleマップと緯度のフォーム連携
  onBlurMarkerLat() {
    if (!!this.reservationFacilityLatControl.valid) {
      this.reservationFacilityLatControl.setValue(this.round(this.reservationFacilityLatControl.value, 8));
      this.currentPosition = {
        lat: this.round(this.reservationFacilityLatControl.value, 8),
        lng: this.currentPosition.lng
      }
      this.map.panTo(this.currentPosition);
    }
  }

  //Googleマップと経度のフォーム連携
  onBlurMarkerLng() {
    if (!!this.reservationFacilityLngControl.valid) {
      this.reservationFacilityLngControl.setValue(this.round(this.reservationFacilityLngControl.value, 8));
      this.currentPosition = {
        lat: this.currentPosition.lat,
        lng: this.round(this.reservationFacilityLngControl.value, 8)
      }
      this.map.panTo(this.currentPosition);
    }
  }

  //予約設備情報並べ替え
  onDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.reservationFacilityFiles, event.previousIndex, event.currentIndex);
    let files: Array<ApiFile> = [];
    for (const file of this.reservationFacilityFiles) {
      files.push({ file_id: file.id, lang_code: file.lang_code });
    }
    this.reservationFacility!.reservation_facility_files = files;
  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToReservationFacilityId() {
    return this.reservationFacilityIdControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.reservationFacilityIdControl.hasError('pattern')
        ? this.translate.instant('半角英数字ハイフンのみ')
        : '';
  }

  public getErrorMessageToReservationFacilityNames() {
    return this.reservationFacilityNamesControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToReservationFacilityDescs() {
    return this.reservationFacilityDescsControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToReservationUserInputTitles() {
    return this.reservationUserInputTitlesControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToReservationSendMailTitles() {
    return this.reservationSendMailTitlesControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToReservationSendMailMessages1() {
    return this.reservationSendMailMessages1Control.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToReservationCancelMailTitles() {
    return this.reservationCancelMailTitlesControl.hasError('required')
      ? this.translate.instant('必須項目')
    : '';
  }

  public getErrorMessageToReservationCancelMailMessages1() {
    return this.reservationCancelMailMessages1Control.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  // public getErrorMessageToReservationRemindMailTitles() {
  //   return this.reservationRemindMailTitlesControl.hasError('required')
  //   ? this.translate.instant('必須項目')
  //   : '';
  // }

  // public getErrorMessageToReservationRemindMailMessages1() {
  //   return this.reservationRemindMailMessages1Control.hasError('required')
  //   ? this.translate.instant('必須項目')
  //   : '';
  // }

  public getErrorMessageToHallLat() {
    return this.reservationFacilityLatControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.reservationFacilityLatControl.hasError('pattern') || this.reservationFacilityLatControl.hasError('min') || this.reservationFacilityLatControl.hasError('max')
        ? this.translate.instant('-90から90の間で小数第８位まで')
        : '';
  }

  public getErrorMessageToHallLng() {
    return this.reservationFacilityLngControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.reservationFacilityLngControl.hasError('pattern') || this.reservationFacilityLngControl.hasError('min') || this.reservationFacilityLngControl.hasError('max')
        ? this.translate.instant('-180から180の間で小数第８位まで')
        : '';
  }

  public getErrorMessageToReservationStartDate() {
    return this.reservationStartDateControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToReservationEndDate() {
    return this.reservationEndDateControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.reservationEndDateControl.hasError('before_start_date')
        ? this.translate.instant('予約開始日より前の日は設定不可')
        : '';
  }

  public getErrorMessageToOneDay() {
    return this.onedayControl.hasError('select_max_days')
      ? this.translate.instant('3つ以上は選択不可')
      : '';
  }

  public getErrorMessageToReservationCount() {
    return this.reservationCountControl.hasError('pattern')
      ? this.translate.instant('0以上を入力')
      : '';
  }

  public getErrorMessageToReservationCancel() {
    return this.reservationCancelControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToReservationOnHoldMailTitles() {
    return this.reservationOnHoldMailTitlesControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToReservationOnHoldMailMessages1() {
    return this.reservationOnHoldMailMessages1Control.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToReservationLostMailTitles() {
    return this.reservationLostMailTitlesControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToReservationLostMailMessages1() {
    return this.reservationLostMailMessages1Control.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToDispStartDate() {
    return this.translate.instant('表示終了日より後の日は設定不可');
  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToDispEndDate() {
    return this.translate.instant('表示開始日より前の日は設定不可');
  }

  public getErrorMessageToReservationOpenEndDate() {
    return this.translate.instant('開催開始日より前の日は設定不可');
  }

  //フォームの値を各要素に代入
  private createForm() {
    this.reservationFacilityFormGroup = this.formBuilder.group(
      {
        reservationFacilityId: [this.reservationFacility!.reservation_facility_id, [Validators.required, Validators.pattern('^[a-zA-Z0-9-]+$')]],
        reservationFacilityAttributeId: [this.reservationFacility!.reservation_facility_attribute_id],
        reservationFacilityNames: [this.reservationFacility!.reservation_facility_names, [Validators.required]],
        reservationFacilityDescs: [this.reservationFacility!.reservation_facility_descs, [Validators.required]],
        reservationUserInputTitles: [this.reservationFacility!.reservation_user_input_titles, []],
        reservationSendMailTitles: [this.reservationFacility!.reservation_send_mail_titles, [Validators.required]],
        reservationSendMailMessages1: [this.reservationFacility!.reservation_send_mail_messages1, [Validators.required]],
        reservationSendMailMessages2: [this.reservationFacility!.reservation_send_mail_messages2, []],
        reservationSendMailMessages3: [this.reservationFacility!.reservation_send_mail_messages3, []],
        isExhibitInfoMessage: [this.reservationFacility!.is_exhibit_info_message, []],
        isHideReservationCancelDateMessage: [this.reservationFacility!.is_hide_reservation_cancel_date_message, []],
        isHideReservationSendMailCancelMessage: [this.reservationFacility!.is_hide_reservation_send_mail_cancel_message, []],
        secretariatMailAddresses: [this.reservationFacility!.secretariat_mail_addresses, []],
        reservationSecretariatMailMessages1: [this.reservationFacility!.reservation_secretariat_mail_messages1, []],
        reservationCancelMailTitles: [this.reservationFacility!.reservation_cancel_mail_titles, []],
        reservationCancelMailMessages1: [this.reservationFacility!.reservation_cancel_mail_messages1, []],
        reservationCancelMailMessages2: [this.reservationFacility!.reservation_cancel_mail_messages2, []],
        reservationCancelMailMessages3: [this.reservationFacility!.reservation_cancel_mail_messages3, []],
        reservationSecretariatCancelMailMessages1: [this.reservationFacility!.reservation_secretariat_cancel_mail_messages1, []],
        oneday: [this.reservationFacility!.remind_days && this.reservationFacility!.remind_days[0] ? this.reservationFacility!.remind_days[0] : false, []],
        twoday: [this.reservationFacility!.remind_days && this.reservationFacility!.remind_days[1] ? this.reservationFacility!.remind_days[1] : false, , []],
        threeday: [this.reservationFacility!.remind_days && this.reservationFacility!.remind_days[2] ? this.reservationFacility!.remind_days[2] : false, , []],
        fourday: [this.reservationFacility!.remind_days && this.reservationFacility!.remind_days[3] ? this.reservationFacility!.remind_days[3] : false, , []],
        fiveday: [this.reservationFacility!.remind_days && this.reservationFacility!.remind_days[4] ? this.reservationFacility!.remind_days[4] : false, , []],
        sixday: [this.reservationFacility!.remind_days && this.reservationFacility!.remind_days[5] ? this.reservationFacility!.remind_days[5] : false, , []],
        sevenday: [this.reservationFacility!.remind_days && this.reservationFacility!.remind_days[6] ? this.reservationFacility!.remind_days[6] : false, , []],
        reservationRemindMailTitles: [this.reservationFacility!.reservation_remind_mail_titles, []],
        reservationRemindMailMessages1: [this.reservationFacility!.reservation_remind_mail_messages1, []],
        reservationRemindMailMessages2: [this.reservationFacility!.reservation_remind_mail_messages2, []],
        reservationRemindMailMessages3: [this.reservationFacility!.reservation_remind_mail_messages3, []],
        reservationFacilityLat: [this.reservationFacility!.latitude, [Validators.required, Validators.min(-90), Validators.max(90), Validators.pattern('^(\-)?([1-9][0-9]{0,1}|0)(\.[0-9]{1,8})?$')]],
        reservationFacilityLng: [this.reservationFacility!.longitude, [Validators.required, Validators.min(-180), Validators.max(180), Validators.pattern('^(\-)?([1-9][0-9]{0,2}|0)(\.[0-9]{1,8})?$')]],
        showMarker: [this.reservationFacility!.show_marker, []],
        reservationMethod: [this.reservationFacility!.reservation_method, [Validators.required]],
        lotteryMethod: [this.reservationFacility!.lottery_method],
        reservationCancel: [this.reservationFacility!.reservation_cancel, [Validators.required, Validators.pattern('^[0-9]+$')]],
        reservationUnit: [this.reservationFacility!.reservation_unit],
        reservationCount: [this.reservationFacility!.reservation_count, [Validators.pattern('^[0-9]+$')]],
        dispStartDate: [this.reservationFacility!.disp_start_date, []],
        dispEndDate: [this.reservationFacility!.disp_end_date, []],
        reservationStartDate: [this.reservationFacility!.reservation_start_date, [Validators.required, Validators.pattern('^[0-9]+$')]],
        reservationEndDate: [this.reservationFacility!.reservation_end_date, [Validators.required, Validators.pattern('^[0-9]+$')]],
        reservationOpenStartDate: [this.reservationFacility!.reservation_open_start_date, []],
        reservationOpenEndDate: [this.reservationFacility!.reservation_open_end_date, []],
        isHideReservationEndDate: [this.reservationFacility!.is_hide_reservation_end_date, []],
        sunday: [this.reservationFacility!.holidays[0], []],
        monday: [this.reservationFacility!.holidays[1], []],
        tuesday: [this.reservationFacility!.holidays[2], []],
        wednesday: [this.reservationFacility!.holidays[3], []],
        thursday: [this.reservationFacility!.holidays[4], []],
        friday: [this.reservationFacility!.holidays[5], []],
        saturday: [this.reservationFacility!.holidays[6], []],
        isVisibledCompanyName: [this.reservationFacility!.is_visibled_company_name, []],
        isVisibledDepartment: [this.reservationFacility!.is_visibled_department, []],
        isVisibledJobTitle: [this.reservationFacility!.is_visibled_job_title, []],
        isVisibledSurnameChinese: [this.reservationFacility!.is_visibled_surname_chinese, []],
        isVisibledNameChinese: [this.reservationFacility!.is_visibled_name_chinese, []],
        isVisibledFamilyName: [this.reservationFacility!.is_visibled_family_name, []],
        isVisibledFirstName: [this.reservationFacility!.is_visibled_first_name, []],
        isVisibledGender: [this.reservationFacility!.is_visibled_gender, []],
        isVisibledBirthday: [this.reservationFacility!.is_visibled_birthday, []],
        isVisibledAddress: [this.reservationFacility!.is_visibled_address, []],
        isVisibledMobilePhoneNumber: [this.reservationFacility!.is_visibled_mobile_phone_number, []],
        isVisibledUserRequest: [this.reservationFacility!.is_visibled_user_request, []],
        isHideReservationCondition: [this.reservationFacility!.is_hide_reservation_condition, []],
        isMultiSelect: [this.reservationFacility!.is_multi_select, []],
        reservationOnHoldMailTitles: [this.reservationFacility!.reservation_on_hold_mail_titles, this.reservationFacility!.reservation_method === AppConst.RESERVATION_METHOD_ON_HOLD ? [Validators.required] : []],
        reservationOnHoldMailMessages1: [this.reservationFacility!.reservation_on_hold_mail_messages1, this.reservationFacility!.reservation_method === AppConst.RESERVATION_METHOD_ON_HOLD ? [Validators.required] : []],
        reservationOnHoldMailMessages2: [this.reservationFacility!.reservation_on_hold_mail_messages2, []],
        reservationOnHoldMailMessages3: [this.reservationFacility!.reservation_on_hold_mail_messages3, []],
        reservationLostMailTitles: [this.reservationFacility!.reservation_lost_mail_titles, this.reservationFacility!.reservation_method === AppConst.RESERVATION_METHOD_ON_HOLD ? [Validators.required] : []],
        reservationLostMailMessages1: [this.reservationFacility!.reservation_lost_mail_messages1, this.reservationFacility!.reservation_method === AppConst.RESERVATION_METHOD_ON_HOLD ? [Validators.required] : []],
        reservationLostMailMessages2: [this.reservationFacility!.reservation_lost_mail_messages2, []],
        reservationLostMailMessages3: [this.reservationFacility!.reservation_lost_mail_messages3, []],
        reservationLotteryDate: [this.reservationFacility!.reservation_lottery_date, []],
        splatsApiType: [!!this.reservationFacility!.splats_api_type ? this.reservationFacility!.splats_api_type : 0, []],
        splatsKeyDeviceId: [!!this.reservationFacility!.splats_key_device_id ? this.reservationFacility!.splats_key_device_id : '', []],
        splatsUnitNo: [!!this.reservationFacility!.splats_unit_no ? this.reservationFacility!.splats_unit_no : '', []],
        splatsBorrowGraceMinutes: [!!this.reservationFacility!.splats_borrow_grace_minutes ? this.reservationFacility!.splats_borrow_grace_minutes : 0, []],
        splatsReturnGraceMinutes: [!!this.reservationFacility!.splats_return_grace_minutes ? this.reservationFacility!.splats_return_grace_minutes : 0, []],
        isVisibledSplatsQrCompanyName: [this.reservationFacility!.is_visibled_splats_qr_company_name, []],
        isVisibledSplatsQrDepartment: [this.reservationFacility!.is_visibled_splats_qr_department, []],
        isVisibledSplatsQrJobTitle: [this.reservationFacility!.is_visibled_splats_qr_job_title, []],
        isVisibledSplatsQrSurnameNameChinese: [this.reservationFacility!.is_visibled_splats_qr_surname_name_chinese, []],
        isVisibledSplatsQrFamilyFirstName: [this.reservationFacility!.is_visibled_splats_qr_family_first_name, []],
        isVisibledSplatsQrGender: [this.reservationFacility!.is_visibled_splats_qr_gender, []],
        isVisibledSplatsQrBirthday: [this.reservationFacility!.is_visibled_splats_qr_birthday, []],
        isVisibledSplatsQrAddress: [this.reservationFacility!.is_visibled_splats_qr_address, []],
        isVisibledSplatsQrMobilePhoneNumber: [this.reservationFacility!.is_visibled_splats_qr_mobile_phone_number, []],
        isVisibledSplatsQrUserRequest: [this.reservationFacility!.is_visibled_splats_qr_user_request, []],
      }, {
        validator: [this.isValidReservationDate, this.isValidReservationOpenDate, this.isValidRemindMailDate, this.isValidDispDate, this.isValidSplatsKey]
      }
    );
  }

  //予約設備画像ファイル設定
  private getFiles() {
    this.reservationFacilityFiles = [];
    if (!!this.reservationFacility!.reservation_facility_files && this.reservationFacility!.reservation_facility_files.length > 0) {
      // NOTE: in で取得できるのは最大10までのため、該当プロジェクトのアップロードファイルを全て取得してから
      //       予約設備情報に登録されている id で絞り込む。
      this.angularFirestore.collection<UploadedFile>(
        AppConst.FIRESTORE_UPLOADED_FILES, ref => ref.where('project_id', '==', this.projectId)
      ).valueChanges({ idField: 'id' }).subscribe(docs => {
        this.reservationFacilityFiles = [];
        if (!!docs) {
          for (const reservationFacilityFile of this.reservationFacility!.reservation_facility_files!) {
            for (const uploadedFile of docs) {
              if (reservationFacilityFile.file_id === uploadedFile.id) {
                const settingFile: SettingFile = {
                  id: uploadedFile.id,
                  file_name: uploadedFile.file_name,
                  download_url: uploadedFile.download_url,
                  lang_code: reservationFacilityFile.lang_code,
                }
                this.reservationFacilityFiles.push(settingFile);
                break;
              }
            }
          }
        }
      });
    }
  }

  //変更された言語を登録
  changeReservationFacilityFileLang(i: number, event: any) {
    this.reservationFacility!.reservation_facility_files![i].lang_code = event.value;
    this.reservationFacilityFiles![i].lang_code = event.value;
  }

  //更新ボタン
  addReservationFacility(): void {
    if (this.reservationFacilityFormGroup.valid) {
      let error_flag = false;
      // エラーメッセージ表示の際の置き換え
      if (!!error_flag) {
        alert(this.translate.instant('時間枠の入力に誤りがあります。'));
        return;
      }
      for (const reservation_select_time of this.reservationFacility!.reservation_select_times) {
        if (reservation_select_time.items.length > 0) {
          if (!reservation_select_time.items || reservation_select_time.items.length !== 4 || reservation_select_time.items.includes('')) {
            error_flag = true;
          }
          if (!reservation_select_time.value || reservation_select_time.value == '') {
            error_flag = true;
          } else {
            if (reservation_select_time.value < 0) {
              error_flag = true;
            }
          }
        } else {
          error_flag = true;
        }
      }
      if (!!error_flag) {
        alert(this.translate.instant('時間枠の入力に誤りがあります。'));
        return;
      }
      if (this.reservationUnitControl.value === AppConst.RESERVATION_UNIT_PERIOD) {
        if (!this.reservationCountControl.value || this.reservationCountControl.value == '') {
          alert(this.translate.instant('最大予約数の入力に誤りがあります。'));
          return;
        }
      }
      if (this.reservationOpenEndDateControl.value) {
        if (new Date(this.reservationOpenStartDateControl.value).getTime() === new Date(this.reservationOpenEndDateControl.value).getTime()) {
          this.reservationOpenEndDateControl.setValue(null);
        }
      }
      this.reservationFacility!.reservation_facility_id = this.reservationFacilityIdControl.value;
      this.reservationFacility!.reservation_facility_attribute_id = this.reservationFacilityAttributeIdControl.value;
      this.reservationFacility!.reservation_facility_names = this.reservationFacilityNamesControl.value;
      this.reservationFacility!.reservation_facility_descs = this.reservationFacilityDescsControl.value;
      this.reservationFacility!.reservation_user_input_titles = this.reservationUserInputTitlesControl.value;
      this.reservationFacility!.reservation_send_mail_titles = this.reservationSendMailTitlesControl.value;
      this.reservationFacility!.reservation_send_mail_messages1 = this.reservationSendMailMessages1Control.value;
      this.reservationFacility!.reservation_send_mail_messages2 = this.reservationSendMailMessages2Control.value;
      this.reservationFacility!.reservation_send_mail_messages3 = this.reservationSendMailMessages3Control.value;
      this.reservationFacility!.secretariat_mail_addresses = this.secretariatMailAddressesControl.value;
      this.reservationFacility!.reservation_secretariat_mail_messages1 = this.reservationSecretariatMailMessages1Control.value;
      this.reservationFacility!.is_exhibit_info_message = this.isExhibitInfoMessageControl.value;
      this.reservationFacility!.is_hide_reservation_cancel_date_message = this.isHideReservationCancelDateMessageControl.value;
      this.reservationFacility!.is_hide_reservation_send_mail_cancel_message = this.isHideReservationSendMailCancelMessageControl.value;
      this.reservationFacility!.remind_days = [this.onedayControl.value, this.twodayControl.value, this.threedayControl.value, this.fourdayControl.value, this.fivedayControl.value, this.sixdayControl.value, this.sevendayControl.value];
      this.reservationFacility!.reservation_remind_mail_titles = this.reservationRemindMailTitlesControl.value;
      this.reservationFacility!.reservation_remind_mail_messages1 = this.reservationRemindMailMessages1Control.value;
      this.reservationFacility!.reservation_remind_mail_messages2 = this.reservationRemindMailMessages2Control.value;
      this.reservationFacility!.reservation_remind_mail_messages3 = this.reservationRemindMailMessages3Control.value;
      this.reservationFacility!.reservation_cancel_mail_titles = this.reservationCancelMailTitlesControl.value;
      this.reservationFacility!.reservation_cancel_mail_messages1 = this.reservationCancelMailMessages1Control.value;
      this.reservationFacility!.reservation_cancel_mail_messages2 = this.reservationCancelMailMessages2Control.value;
      this.reservationFacility!.reservation_cancel_mail_messages3 = this.reservationCancelMailMessages3Control.value;
      this.reservationFacility!.reservation_secretariat_cancel_mail_messages1 = this.reservationSecretariatCancelMailMessages1Control.value;
      this.reservationFacility!.latitude = this.reservationFacilityLatControl.value;
      this.reservationFacility!.longitude = this.reservationFacilityLngControl.value;
      this.reservationFacility!.show_marker = this.showMarkerControl.value;
      this.reservationFacility!.reservation_method = this.reservationMethodControl.value;
      this.reservationFacility!.lottery_method = this.lotteryMethodControl.value;
      this.reservationFacility!.reservation_cancel = this.reservationCancelControl.value;
      this.reservationFacility!.reservation_unit = this.reservationUnitControl.value;
      this.reservationFacility!.reservation_count = this.reservationCountControl.value;
      this.reservationFacility!.disp_start_date = this.dispStartDateControl.value ? this.dispStartDateControl.value : null;
      this.reservationFacility!.disp_end_date = this.dispEndDateControl.value ? this.dispEndDateControl.value : null;
      this.reservationFacility!.reservation_start_date = this.reservationStartDateControl.value;
      this.reservationFacility!.reservation_end_date = this.reservationEndDateControl.value;
      this.reservationFacility!.reservation_open_start_date = this.reservationOpenStartDateControl.value ? this.reservationOpenStartDateControl.value : null;
      this.reservationFacility!.reservation_open_end_date = this.reservationOpenEndDateControl.value ? this.reservationOpenEndDateControl.value : null;
      this.reservationFacility!.is_hide_reservation_end_date = this.isHideReservationEndDateControl.value;
      this.reservationFacility!.holidays = [this.sundayControl.value,this.mondayControl.value,this.tuesdayControl.value,this.wednesdayControl.value,this.thursdayControl.value,this.fridayControl.value,this.saturdayControl.value];
      this.reservationFacility!.is_visibled_company_name = this.isVisibledCompanyNameControl.value;
      this.reservationFacility!.is_visibled_department = this.isVisibledDepartmentControl.value;
      this.reservationFacility!.is_visibled_job_title = this.isVisibledJobTitleControl.value;
      this.reservationFacility!.is_visibled_surname_chinese = this.isVisibledSurnameChineseControl.value;
      this.reservationFacility!.is_visibled_name_chinese = this.isVisibledNameChineseControl.value;
      this.reservationFacility!.is_visibled_family_name = this.isVisibledFamilyNameControl.value;
      this.reservationFacility!.is_visibled_first_name = this.isVisibledFirstNameControl.value;
      this.reservationFacility!.is_visibled_gender = this.isVisibledGenderControl.value;
      this.reservationFacility!.is_visibled_birthday = this.isVisibledBirthdayControl.value;
      this.reservationFacility!.is_visibled_address = this.isVisibledAddressControl.value;
      this.reservationFacility!.is_visibled_mobile_phone_number = this.isVisibledMobilePhoneNumberControl.value;
      this.reservationFacility!.is_visibled_user_request = this.isVisibledUserRequestControl.value;
      this.reservationFacility!.is_hide_reservation_condition = this.isHideReservationConditionControl.value;
      this.reservationFacility!.is_multi_select = this.isMultiSelectControl.value;
      this.reservationFacility!.reservation_on_hold_mail_titles = this.reservationOnHoldMailTitlesControl.value;
      this.reservationFacility!.reservation_on_hold_mail_messages1 = this.reservationOnHoldMailMessages1Control.value;
      this.reservationFacility!.reservation_on_hold_mail_messages2 = this.reservationOnHoldMailMessages2Control.value;
      this.reservationFacility!.reservation_on_hold_mail_messages3 = this.reservationOnHoldMailMessages3Control.value;
      this.reservationFacility!.reservation_lost_mail_titles = this.reservationLostMailTitlesControl.value;
      this.reservationFacility!.reservation_lost_mail_messages1 = this.reservationLostMailMessages1Control.value;
      this.reservationFacility!.reservation_lost_mail_messages2 = this.reservationLostMailMessages2Control.value;
      this.reservationFacility!.reservation_lost_mail_messages3 = this.reservationLostMailMessages3Control.value;
      this.reservationFacility!.reservation_lottery_date = this.reservationLotteryDateControl.value;
      this.reservationFacility!.splats_api_type = this.splatsApiTypeControl.value;
      this.reservationFacility!.splats_key_device_id = this.splatsKeyDeviceIdControl.value;
      this.reservationFacility!.splats_unit_no = this.splatsUnitNoControl.value;
      this.reservationFacility!.splats_borrow_grace_minutes = this.splatsBorrowGraceMinutesControl.value;
      this.reservationFacility!.splats_return_grace_minutes = this.splatsReturnGraceMinutesControl.value;
      this.reservationFacility!.is_visibled_splats_qr_company_name = this.isVisibledSplatsQrCompanyNameControl.value;
      this.reservationFacility!.is_visibled_splats_qr_department = this.isVisibledSplatsQrDepartmentControl.value;
      this.reservationFacility!.is_visibled_splats_qr_job_title = this.isVisibledSplatsQrJobTitleControl.value;
      this.reservationFacility!.is_visibled_splats_qr_surname_name_chinese = this.isVisibledSplatsQrSurnameNameChineseControl.value;
      this.reservationFacility!.is_visibled_splats_qr_family_first_name = this.isVisibledSplatsQrFamilyFirstNameControl.value;
      this.reservationFacility!.is_visibled_splats_qr_gender = this.isVisibledSplatsQrGenderControl.value;
      this.reservationFacility!.is_visibled_splats_qr_birthday = this.isVisibledSplatsQrBirthdayControl.value;
      this.reservationFacility!.is_visibled_splats_qr_address = this.isVisibledSplatsQrAddressControl.value;
      this.reservationFacility!.is_visibled_splats_qr_mobile_phone_number = this.isVisibledSplatsQrMobilePhoneNumberControl.value;
      this.reservationFacility!.is_visibled_splats_qr_user_request = this.isVisibledSplatsQrUserRequestControl.value;
      if (this.reservationFacility) {
        let request: ApiSetReservationFacilitiesRequest = {
          access_token: '',
          change_type: this.data.change_type,
          reservation_facilities: [this.reservationFacility]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setReservationFacilities(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じIDが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  // 予約設備名称ダイアログ
  openReservationFacilityNameDialog(): void {
    const dialogRef = this.dialog.open(MultiNameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.reservationFacility!.reservation_facility_names }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_facility_names = result;
        this.reservationFacilityNamesControl.setValue(this.reservationFacility!.reservation_facility_names);
      }
    });
  }

  // 予約設備詳細ダイアログ
  openReservationFacilityDescDialog(): void {
    const dialogRef = this.dialog.open(MultiDescDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { descs: this.reservationFacility!.reservation_facility_descs }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_facility_descs = result;
        this.reservationFacilityDescsControl.setValue(this.reservationFacility!.reservation_facility_descs);
      }
    });
  }

  //ユーザー入力タイトルダイアログ
  openReservationUserInputTitleDialog(): void {
    const dialogRef = this.dialog.open(MultiUserInputTitleDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { user_input_titles: this.reservationFacility!.reservation_user_input_titles }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_user_input_titles = result;
        this.reservationUserInputTitlesControl.setValue(this.reservationFacility!.reservation_user_input_titles);
      }
    });
  }

  // 予約完了時メール送信タイトルダイアログ
  openReservationSendMailMessageTitleDialog(): void {
    const dialogRef = this.dialog.open(MultiSendMailTitleDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { send_mail_titles: this.reservationFacility!.reservation_send_mail_titles }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_send_mail_titles = result;
        this.reservationSendMailTitlesControl.setValue(this.reservationFacility!.reservation_send_mail_titles);
      }
    });
  }

  // 予約完了時メール送信本文（文頭）ダイアログ
  openReservationSendMailMessageHeaderDialog(): void {
    const dialogRef = this.dialog.open(MultiSendMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { send_mail_messages: this.reservationFacility!.reservation_send_mail_messages1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_send_mail_messages1 = result;
        this.reservationSendMailMessages1Control.setValue(this.reservationFacility!.reservation_send_mail_messages1);
      }
    });
  }

  // 予約完了時メール送信本文（文中）ダイアログ
  openReservationSendMailMessageMiddleDialog(): void {
    const dialogRef = this.dialog.open(MultiSendMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { send_mail_messages: this.reservationFacility!.reservation_send_mail_messages2 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_send_mail_messages2 = result;
        this.reservationSendMailMessages2Control.setValue(this.reservationFacility!.reservation_send_mail_messages2);
      }
    });
  }

  // 予約完了時メール送信本文（末尾）ダイアログ
  openReservationSendMailMessageFooterDialog(): void {
    const dialogRef = this.dialog.open(MultiSendMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { send_mail_messages: this.reservationFacility!.reservation_send_mail_messages3 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_send_mail_messages3 = result;
        this.reservationSendMailMessages3Control.setValue(this.reservationFacility!.reservation_send_mail_messages3);
      }
    });
  }

  // 事務局通知メール送信本文（文頭）ダイアログ
  openReservationSecretariatMailMessageHeaderDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_secretariat_mail_messages1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_secretariat_mail_messages1 = result;
        this.reservationSecretariatMailMessages1Control.setValue(this.reservationFacility!.reservation_secretariat_mail_messages1);
      }
    });
  }

  // キャンセルメール送信タイトルダイアログ
  openReservationCancelMailMessageTitleDialog(): void {
    const dialogRef = this.dialog.open(MultiMailTitleDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_titles: this.reservationFacility!.reservation_cancel_mail_titles }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_cancel_mail_titles = result;
        this.reservationCancelMailTitlesControl.setValue(this.reservationFacility!.reservation_cancel_mail_titles);
      }
    });
  }

  // キャンセルメール送信本文（文頭）ダイアログ
  openReservationCancelMailMessageHeaderDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_cancel_mail_messages1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_cancel_mail_messages1 = result;
        this.reservationCancelMailMessages1Control.setValue(this.reservationFacility!.reservation_cancel_mail_messages1);
      }
    });
  }

  // キャンセルメール送信本文（文中）ダイアログ
  openReservationCancelMailMessageMiddleDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_cancel_mail_messages2 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_cancel_mail_messages2 = result;
        this.reservationCancelMailMessages2Control.setValue(this.reservationFacility!.reservation_cancel_mail_messages2);
      }
    });
  }

  // キャンセルメール送信本文（末尾）ダイアログ
  openReservationCancelMailMessageFooterDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_cancel_mail_messages3 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_cancel_mail_messages3 = result;
        this.reservationCancelMailMessages3Control.setValue(this.reservationFacility!.reservation_cancel_mail_messages3);
      }
    });
  }

  // 事務局通知キャンセルメール本文（文頭）ダイアログ
  openReservationSecretariatCancelMailMessageHeaderDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_secretariat_cancel_mail_messages1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_secretariat_cancel_mail_messages1 = result;
        this.reservationSecretariatCancelMailMessages1Control.setValue(this.reservationFacility!.reservation_secretariat_cancel_mail_messages1);
      }
    });
  }

  // リマインドメール送信タイトルダイアログ
  openReservationRemindMailMessageTitleDialog(): void {
    const dialogRef = this.dialog.open(MultiMailTitleDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_titles: this.reservationFacility!.reservation_remind_mail_titles }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_remind_mail_titles = result;
        this.reservationRemindMailTitlesControl.setValue(this.reservationFacility!.reservation_remind_mail_titles);
      }
    });
  }

  // リマインドメール送信本文（文頭）ダイアログ
  openReservationRemindMailMessageHeaderDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_remind_mail_messages1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_remind_mail_messages1 = result;
        this.reservationRemindMailMessages1Control.setValue(this.reservationFacility!.reservation_remind_mail_messages1);
      }
    });
  }

  // リマインドメール送信本文（文中）ダイアログ
  openReservationRemindMailMessageMiddleDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_remind_mail_messages2 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_remind_mail_messages2 = result;
        this.reservationRemindMailMessages2Control.setValue(this.reservationFacility!.reservation_remind_mail_messages2);
      }
    });
  }

  // リマインドメール送信本文（末尾）ダイアログ
  openReservationRemindMailMessageFooterDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_remind_mail_messages3 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_remind_mail_messages3 = result;
        this.reservationRemindMailMessages3Control.setValue(this.reservationFacility!.reservation_remind_mail_messages3);
      }
    });
  }

  //予約設備画像ファイル選択ダイアログ
  openSelectFilesDialog(): void {
    const dialogRef = this.dialog.open(SelectUploadedFileDialogComponent, {
      width: '80%',
      height: '90%',
      disableClose: true,
      data: { uploadedFile: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result && result.length > 0) {
        for (const row of result) {
          const lang = this.projectLanguages[0].lang_code;
          this.reservationFacility!.reservation_facility_files!.push({ file_id: row.id, lang_code: lang });
        }
        this.getFiles();
      }
    });
  }

  // 設問選択ダイアログ
  openSelectQuestionsDialog(): void {
    const dialogRef = this.dialog.open(SelectReservationQuestionsDialogComponent, {
      width: '80%',
      disableClose: true,
      data: { floor: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result && result.length > 0) {
        if (!this.reservationFacility!.questions) {
          this.reservationFacility!.questions = new Array<ApiReservationQuestion>();
        }
        var questionIds = [];
        for (const question of this.reservationFacility!.questions) {
          if (question) {
            questionIds.push(question.question_id);
          }
        }
        let isChanged: boolean = false;
        for (const row of result) {
          if (!questionIds.includes(row.question_id)) {
            this.reservationFacility!.questions.push(row);
            isChanged = true;
          }
        }
        if (isChanged && this.reservationFacility) {
          this.getQuestionIDs();
        }
      }
    });
  }

  // 予約保留メール送信タイトルダイアログ
  openReservationOnHoldMailMessageTitleDialog(): void {
    const dialogRef = this.dialog.open(MultiMailTitleDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_titles: this.reservationFacility!.reservation_on_hold_mail_titles }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_on_hold_mail_titles = result;
        this.reservationOnHoldMailTitlesControl.setValue(this.reservationFacility!.reservation_on_hold_mail_titles);
      }
    });
  }

  // 予約保留メール送信本文（文頭）ダイアログ
  openReservationOnHoldMailMessageHeaderDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_on_hold_mail_messages1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_on_hold_mail_messages1 = result;
        this.reservationOnHoldMailMessages1Control.setValue(this.reservationFacility!.reservation_on_hold_mail_messages1);
      }
    });
  }

  // 予約保留メール送信本文（文中）ダイアログ
  openReservationOnHoldMailMessageMiddleDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_on_hold_mail_messages2 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_on_hold_mail_messages2 = result;
        this.reservationOnHoldMailMessages2Control.setValue(this.reservationFacility!.reservation_on_hold_mail_messages2);
      }
    });
  }

  // 予約保留メール送信本文（末尾）ダイアログ
  openReservationOnHoldMailMessageFooterDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_on_hold_mail_messages3 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_on_hold_mail_messages3 = result;
        this.reservationOnHoldMailMessages3Control.setValue(this.reservationFacility!.reservation_on_hold_mail_messages3);
      }
    });
  }

  // 予約落選メール送信タイトルダイアログ
  openReservationLostMailMessageTitleDialog(): void {
    const dialogRef = this.dialog.open(MultiMailTitleDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_titles: this.reservationFacility!.reservation_lost_mail_titles }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_lost_mail_titles = result;
        this.reservationLostMailTitlesControl.setValue(this.reservationFacility!.reservation_lost_mail_titles);
      }
    });
  }

  // 予約落選メール送信本文（文頭）ダイアログ
  openReservationLostMailMessageHeaderDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_lost_mail_messages1 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_lost_mail_messages1 = result;
        this.reservationLostMailMessages1Control.setValue(this.reservationFacility!.reservation_lost_mail_messages1);
      }
    });
  }

  // 予約落選メール送信本文（文中）ダイアログ
  openReservationLostMailMessageMiddleDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_lost_mail_messages2 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_lost_mail_messages2 = result;
        this.reservationLostMailMessages2Control.setValue(this.reservationFacility!.reservation_lost_mail_messages2);
      }
    });
  }

  // 予約落選メール送信本文（末尾）ダイアログ
  openReservationLostMailMessageFooterDialog(): void {
    const dialogRef = this.dialog.open(MultiMailMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { mail_messages: this.reservationFacility!.reservation_lost_mail_messages3 }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_lost_mail_messages3 = result;
        this.reservationLostMailMessages3Control.setValue(this.reservationFacility!.reservation_lost_mail_messages3);
      }
    });
  }

  // 施設に紐付く設問情報設定
  private getQuestionIDs() {
    this.questionIDs = [];
    if (!!this.reservationFacility! && !!this.reservationFacility!.questions && this.reservationFacility!.questions.length > 0) {
      for (const question of this.reservationFacility?.questions) {
        this.questionIDs.push(question.question_id);
      }
    }
  }

  // 設問情報並べ替え
  onDropQuestion(event: CdkDragDrop<string[]>) {
    let questions = [];
    if (this.reservationFacility && this.reservationFacility.questions && this.reservationFacility.questions.length > 1) {
      for (const question of this.reservationFacility.questions) {
        questions.push({ ...question });
      }
      moveItemInArray(this.questionIDs, event.previousIndex, event.currentIndex);
      let questionLists: Array<ApiReservationQuestion> = [];
      for (const question_id of this.questionIDs) {
        for (let question of questions) {
          if (question_id === question.question_id) {
            questionLists.push({ ...question });
          }
        }
      }
      this.reservationFacility!.questions = questionLists;
    }
  }

  // 設問リストの削除
  deleteQuestion(question_id: string): void {
    if (!!this.reservationFacility!.questions!) {
      this.reservationFacility!.questions.forEach((question, index) => {
        if (question.question_id == question_id) {
          this.reservationFacility!.questions.splice(index, 1);
        }
      })
    }
  }

  deleteFiles(i: number): void {
    this.reservationFacility!.reservation_facility_files!.splice(i, 1);
    this.getFiles();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  // マップ検索用のキー制御
  onKeyDownFromSearchPlace(keyCode: number): boolean {
    if (keyCode && keyCode === 13) {
      // NOTE: Enterを叩かれると他の項目の編集ボタンが反応してしまうのを防ぐ
      return false;
    }
    return true;
  }

  // マップ検索
  searchMap(): void {
    const places = this.searchBox.getPlaces();
    if (places!.length === 0) {
      return;
    }
    const bounds = new google.maps.LatLngBounds();
    places!.forEach(place => {
      if (!place.geometry || !place.geometry.location) {
        return;
      }
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });
    this.reservationFacilityLatControl.setValue(this.round(bounds.getCenter().lat(), 8));
    this.reservationFacilityLngControl.setValue(this.round(bounds.getCenter().lng(), 8));
    this.currentPosition = {
      lat: this.round(bounds.getCenter().lat(), 8),
      lng: this.round(bounds.getCenter().lng(), 8)
    }
    this.map.panTo(this.currentPosition);
  }

  // マップ検索フィールドクリア
  clearMapSearchField(): void {
    this.searchField.nativeElement.value = "";
  }

  // 予約可能期間整合制チェック
  isValidReservationDate(ac: AbstractControl) {
    const startDate = ac.get('reservationStartDate');
    const endDate = ac.get('reservationEndDate');
    endDate?.setErrors(null);
    if (!!startDate && !!endDate) {
      if (startDate.value < endDate.value) {
        endDate.setErrors({ before_start_date: true });
      }
    }
  }

  // 予約可能期間整合制チェック
  isValidReservationOpenDate(ac: AbstractControl) {
    const startDate = ac.get('reservationOpenStartDate');
    const endDate = ac.get('reservationOpenEndDate');
    endDate?.setErrors(null);
    if (!!startDate && !!endDate && !!startDate.value && !!endDate.value) {
      if (startDate.value > endDate.value) {
        endDate.setErrors({ before_start_date: true });
      }
    }
  }

  clearReservationOpenStartDate(): void {
    this.reservationOpenStartDateControl.setValue(null);
  }

  clearReservationOpenEndDate(): void {
    this.reservationOpenEndDateControl.setValue(null);
  }

  // リマインドメール送信日チェック
  isValidRemindMailDate(ac: AbstractControl) {
    const oneday = ac.get('oneday');
    const twoday = ac.get('twoday');
    const threeday = ac.get('threeday');
    const fourday = ac.get('fourday');
    const fiveday = ac.get('fiveday');
    const sixday = ac.get('sixday');
    const sevenday = ac.get('sevenday');
    var remindDays = [oneday?.value, twoday?.value, threeday?.value, fourday?.value, fiveday?.value, sixday?.value, sevenday?.value];
    // 3つ以上は選択不可
    const count = remindDays.filter(item => item == true).length;
    oneday?.setErrors(null);
    if (oneday && count > 2) {
      oneday.setErrors({ select_max_days: true });
    }
  }

  // 予約表示期間整合制チェック
  isValidDispDate(ac: AbstractControl) {
    const dispStartDate = ac.get('dispStartDate');
    const dispEndDate = ac.get('dispEndDate');
    if (!!dispStartDate && !!dispEndDate && !!dispStartDate.value && !!dispEndDate.value) {
      if (dispStartDate.value > dispEndDate.value) {
        dispStartDate.setErrors({ before_disp_start_date: true });
        dispEndDate.setErrors({ before_disp_start_date: true });
      } else {
        dispStartDate.setErrors(null);
        dispEndDate.setErrors(null);
      }
    }
  }

  setRemindCount() {
    var count = 0;
    if (this.onedayControl.value == true) { count++; }
    if (this.twodayControl.value == true) { count++; }
    if (this.threedayControl.value == true) { count++; }
    if (this.fourdayControl.value == true) { count++; }
    if (this.fivedayControl.value == true) { count++; }
    if (this.sixdayControl.value == true) { count++; }
    if (this.sevendayControl.value == true) { count++; }
    this.remindCount = count;
  }

  // ユーザー予約の通知メールアドレス追加ボタン
  appendMail(): void {
    if (!this.reservationFacility!.secretariat_mail_addresses) {
      this.reservationFacility!.secretariat_mail_addresses = new Array();
    }
    this.reservationFacility!.secretariat_mail_addresses!.push('');
  }

  // ユーザー予約の通知メールアドレスが更新された時
  onSelectMailChange(index: number, event: any): void {
    this.reservationFacility!.secretariat_mail_addresses![index] = event.target.value;
  }

  // ユーザー予約の通知メールアドレスが削除された時
  deleteMail(index: number): void {
    this.reservationFacility!.secretariat_mail_addresses!.splice(index, 1);
  }

  clearReservationStartDate(): void {
    this.reservationStartDateControl.setValue(null);
  }

  clearReservationEndDate(): void {
    this.reservationEndDateControl.setValue(null);
  }

  //予約枠ダイアログ
  openReservationItemDialog(index: number): void {
    const dialogRef = this.dialog.open(MultiRitemDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { items: this.reservationFacility!.reservation_select_times[index].items }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.reservationFacility!.reservation_select_times![index].items = result;
      }
    });
  }

  onSelectValueChange(event: any, index: number): void {
    this.reservationFacility!.reservation_select_times![index].value = event.target.value;
  }

  onSelectItemChange(index: number, item_index: number, value: string): void {
    this.reservationFacility!.reservation_select_times![index].items[item_index] = value;
  }

  //予約枠追加ボタン
  appendTime(): void {
    if (!this.reservationFacility!.reservation_select_times) {
      this.reservationFacility!.reservation_select_times = new Array();
    }
    this.reservationFacility!.reservation_select_times!.push({
      index: this.getUniqueStr(),
      items: ['00', '00', '00', '00'],
      value: '',
      // related_display_flag: false,
      // related_campaign_item: null
    });
  }

  //予約枠削除ボタン
  deleteClick(index: number): void {
    this.reservationFacility!.reservation_select_times!.splice(index, 1);
  }

  //予約枠並べ替え
  onDropSelectItem(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.reservationFacility!.reservation_select_times, event.previousIndex, event.currentIndex);
  }

  getUniqueStr() {
    var strong = 1000;
    return new Date().getTime().toString(16) + Math.floor(strong * Math.random()).toString(16) + Math.floor(strong * Math.random()).toString(16)
  }

  clearDispStartDate() {
    this.dispStartDateControl.setValue(null);
  }

  clearDispEndDate() {
    this.dispEndDateControl.setValue(null);
  }

  // 予約方式による予約保留メールと予約落選メールのバリデーションの切り替え
  changeReservationMethod() {
    const validator = [AppConst.RESERVATION_METHOD_ON_HOLD, AppConst.RESERVATION_METHOD_LOTTERY].includes(this.reservationMethodControl.value) ? [Validators.required] : [];
    this.reservationOnHoldMailTitlesControl.setValidators(validator);
    this.reservationOnHoldMailMessages1Control.setValidators(validator);
    this.reservationLostMailTitlesControl.setValidators(validator);
    this.reservationLostMailMessages1Control.setValidators(validator);
    this.reservationOnHoldMailTitlesControl.updateValueAndValidity();
    this.reservationOnHoldMailMessages1Control.updateValueAndValidity();
    this.reservationLostMailTitlesControl.updateValueAndValidity();
    this.reservationLostMailMessages1Control.updateValueAndValidity();
  }

  // SPLATS環境変更
  onApiTypeChange(): void {
    this.splatsKeyDeviceIdControl.setValue('');
    this.splatsUnitNoControl.setValue('');
    this.splatsBorrowGraceMinutesControl.setValue(0);
    this.splatsReturnGraceMinutesControl.setValue(0);
    this.units = [];
  }

  // SPLATSキーボックス変更
  onKeyDeviceChange(event: any): void {
    this.splatsUnitNoControl.setValue('');
    this.splatsBorrowGraceMinutesControl.setValue(0);
    this.splatsReturnGraceMinutesControl.setValue(0);
    this.createUnitNo(event.value)
  }

  // SPLATSキー作成
  createUnitNo(keyDeviceId: string) {
    let units: any[] = [{no: '', name: '', is_used: false}];
    const keyDevice = this.keyDevices.find(keyDevice => keyDevice.id === keyDeviceId);
    if (!!keyDevice) {
      for (const unit of keyDevice.units) {
        let isUsed = false;
        for (const resevationFacility of this.reservationFacilities) {
          if (resevationFacility.splats_key_device_id === keyDeviceId && resevationFacility.splats_unit_no === unit.no && resevationFacility.id !== this.reservationFacility!.id) {
            isUsed = true;
            break;
          }
        }
        units.push({no: unit.no, name: unit.name, is_used: isUsed});
      }
    }
    this.units = units;
  }

  // キー番号チェック
  isValidSplatsKey(ac: AbstractControl) {
    const splatsKeyDeviceId = ac.get('splatsKeyDeviceId');
    const splatsUnitNo = ac.get('splatsUnitNo');
    if (!!splatsKeyDeviceId && !!splatsUnitNo) {
      if (!!splatsKeyDeviceId.value && !splatsUnitNo.value) {
        splatsUnitNo.setErrors({ require: true });
      } else {
        splatsUnitNo.setErrors(null);
      }
    }
  }

  isValidSplatsQr(): boolean {
    let count = 0;
    count += this.isVisibledSplatsQrCompanyNameControl.value ? 1 : 0;
    count += this.isVisibledSplatsQrDepartmentControl.value ? 1 : 0;
    count += this.isVisibledSplatsQrJobTitleControl.value ? 1 : 0;
    count += this.isVisibledSplatsQrSurnameNameChineseControl.value ? 1 : 0;
    count += this.isVisibledSplatsQrFamilyFirstNameControl.value ? 1 : 0;
    count += this.isVisibledSplatsQrGenderControl.value ? 1 : 0;
    count += this.isVisibledSplatsQrBirthdayControl.value ? 1 : 0;
    count += this.isVisibledSplatsQrAddressControl.value ? 1 : 0;
    count += this.isVisibledSplatsQrMobilePhoneNumberControl.value ? 1 : 0;
    count += this.isVisibledSplatsQrUserRequestControl.value ? 1 : 0;
    return count <= 5;
  }

}
